// extracted by mini-css-extract-plugin
export default {"textListBlock":"TextListBlock_textListBlock__KfaHk"};